import { Injectable } from '@angular/core';
import { EntityPagesTitle, PagesTitle } from 'src/app/app-pages-title/app-pages-title';
import { promiseWithCatch } from 'src/app/common/app.helpers';
import { RouteService } from 'src/app/services/route-service.abstract';
import { CreateCommunityRequestBasic, UpdateCommunityRequestBasic, UserRelationToGroup } from 'src/app/swagger-api';
import { CommunityView } from './communities-store';
import { ManageCommunityService } from './manage-community.service';

@Injectable({ providedIn: 'root' })
export class CommunityRouteService<
  TCreateRequest extends CreateCommunityRequestBasic,
  TUpdateRequest extends UpdateCommunityRequestBasic,
> extends RouteService<CommunityView, EntityPagesTitle> {
  public constructor(private communityService: ManageCommunityService<TCreateRequest, TUpdateRequest>) {
    super();

    this.subscribeToData(communityService.entityChanged$);
  }

  public loadData(id: string): void {
    this.communityService.fetchEntityData(id);
  }

  public buildTitle({ title }: CommunityView): EntityPagesTitle {
    return {
      viewPage: this.translate(PagesTitle.COMMUNITY_VIEW_PAGE, { communityTitle: title }),
      editPage: this.translate(PagesTitle.COMMUNITY_EDIT_PAGE, { communityTitle: title }),
    };
  }

  public verifyAccess(community: CommunityView): void {
    if (community.actor_role === UserRelationToGroup.Leader || this.sessionService.isAdminSession()) {
      return;
    }

    promiseWithCatch(this.router.navigate([this.communityService.SOCIAL_ENTITY_ROUTE_LINK, community.entity_id]));

    this.informService.showFailureMessage({
      title: '',
      level: 'ERROR',
      content: [{ type: 'text', value: 'MANAGE_COMMUNITY_NO_ACCESS_DESCRIPTION' }],
      replies: [],
    });
  }
}
